import React from 'react';
import { DatePicker } from '../../ui/DatePicker';
import { TimePicker } from '../../ui/TimePicker';
import styles from '../../../styles/components/forms/BookingForm.module.css';

const DateTimeSection = ({ 
    formData, 
    errors, 
    isClicked, 
    isDarkMode, 
    todayDate,
    now,
    onDateChange, 
    onInputChange, 
    onSetDefaultTime,
    onClearError,
    getInputClassName 
}) => {
    return (
        <>
            {/* Departure Date and Time */}
            <div className="col-lg-6">
                <div className={`d-flex flex-column ${styles['form-field-container']}`}>
                    <div className={`d-flex ${styles['date-time-container']}`}>
                        <div className="d-flex flex-column w-50">
                            <label htmlFor="departureDate" className={`${styles['form-labels']} ${isDarkMode ? styles['form-labels-dark'] : ''}`}>
                                Pick Up Date <span className="text-danger">*</span>
                            </label>
                            <DatePicker
                                value={formData.departureDate}
                                onChange={(date) => {
                                    onDateChange('departureDate', date);
                                    onClearError('departureDate');
                                }}
                                minDate={todayDate}
                                placeholder="Select date"
                                className={getInputClassName('departureDate')}
                                isDarkMode={isDarkMode}
                            />
                        </div>
                        <div className="d-flex flex-column w-50 ps-2">
                            <label htmlFor="departureTime" className={`${styles['form-labels']} ${isDarkMode ? styles['form-labels-dark'] : ''}`}>
                                Time
                            </label>
                            <TimePicker
                                value={formData.departureTime}
                                onChange={(time) => {
                                    onInputChange('departureTime', time);
                                    // Don't clear error here - let the validation logic handle it
                                }}
                                onFocus={() => {
                                    if (!formData.departureTime) {
                                        onSetDefaultTime('departureTime');
                                    }
                                }}
                                format24h={false}
                                minuteStep={5}
                                placeholder="Select Time"
                                className={getInputClassName('departureTime')}
                                isDarkMode={isDarkMode}
                                minTime={formData.departureDate === todayDate ? now.format('hh:mm A') : null}
                            />
                        </div>
                    </div>
                    {(errors.departureDate || errors.departureTime) && (
                        <div
                            className={`text-danger ${styles['error-message-container']}`}
                            style={{ minHeight: '20px' }}>
                            {errors.departureDate || errors.departureTime}
                        </div>
                    )}
                </div>
            </div>

            {/* Return Date and Time - Only show for Return trips */}
            {formData.tripType === '2' && (
                <div className="col-lg-6">
                    <div className={`d-flex flex-column ${styles['form-field-container']}`}>
                        <div className={`d-flex ${styles['date-time-container']}`}>
                            <div className="d-flex flex-column w-50">
                                <label htmlFor="returnDate" className={`${styles['form-labels']} ${isDarkMode ? styles['form-labels-dark'] : ''}`}>
                                    Return Date <span className="text-danger">*</span>
                                </label>
                                <DatePicker
                                    value={formData.returnDate}
                                    onChange={(date) => {
                                        onDateChange('returnDate', date);
                                        onClearError('returnDate');
                                    }}
                                    minDate={formData.departureDate || todayDate}
                                    placeholder="Select date"
                                    className={getInputClassName('returnDate')}
                                    isDarkMode={isDarkMode}
                                />
                            </div>
                            <div className="d-flex flex-column w-50 ps-2">
                                <label htmlFor="returnTime" className={`${styles['form-labels']} ${isDarkMode ? styles['form-labels-dark'] : ''}`}>
                                    Time
                                </label>
                                <TimePicker
                                    value={formData.returnTime}
                                    onChange={(time) => {
                                        onInputChange('returnTime', time);
                                        // Don't clear error here - let the validation logic handle it
                                    }}
                                    onFocus={() => {
                                        if (!formData.returnTime) {
                                            onSetDefaultTime('returnTime');
                                        }
                                    }}
                                    format24h={false}
                                    minuteStep={5}
                                    placeholder="Select Time"
                                    className={getInputClassName('returnTime')}
                                    isDarkMode={isDarkMode}
                                    minTime={formData.returnDate === todayDate ? now.format('hh:mm A') : null}
                                />
                            </div>
                        </div>
                        {(errors.returnDate || errors.returnTime) && (
                            <div
                                className={`text-danger ${styles['error-message-container']}`}
                                style={{ minHeight: '20px' }}>
                                {errors.returnDate || errors.returnTime}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default DateTimeSection;
